module.exports = __webpack_public_path__ + "img/brand-06.c2151425.png";